import type { CoreUser } from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

export async function getUserLogged(): Promise<CoreUser> {
  const response = await api.get('/api/me')
  const { data } = deserialize<CoreUser>(response.data)
  if (data) {
    data.business_category_id =
      response?.data?.data?.relationships?.business_category?.data?.id ?? ''
  }

  return data
}
